<template>
  <section id="download" class="download">
    <div class="container">
      <div class="section-header">
        <h2>GO FM Radio - <span class="highlight">Music & Sports</span></h2>
        <p>Access FM radio stations from around the world on your mobile devices</p>
      </div>
      
      <div class="platforms">
        <div class="platform-card" id="ios-platform">
          <div class="platform-icon apple">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
              <path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
            </svg>
          </div>
          <h3>iOS Version</h3>
          <div class="platform-details">
            <p>Latest Version: 2.5.3</p>
            <p>Compatibility: iOS 12.0+</p>
            <p>Size: 28.6 MB</p>
          </div>
          <div class="download-links">
            <a href="https://apps.apple.com/us/app/go-fm-radio-music-sports/id6648771859" class="download-btn web-download" @click.prevent="downloadForIOS">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
                <path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
              </svg>
              Web Download
            </a>
          </div>
        </div>
        
        <div class="platform-card" id="android-platform">
          <div class="platform-icon android">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path fill="currentColor" d="M420.6 301.9a24 24 0 1 1 24-24 24 24 0 0 1 -24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1 -24 24m273.7-144.5 47.9-83a10 10 0 1 0 -17.3-10h0l-48.5 84.1a301.3 301.3 0 0 0 -246.6 0L116.2 64.5a10 10 0 1 0 -17.3 10h0l47.9 83C64.5 202.2 8.2 285.6 0 384H576c-8.2-98.5-64.5-181.8-146.9-226.6"/>
            </svg>
          </div>
          <h3>Android Version</h3>
          <div class="platform-details">
            <p>Latest Version: 2.5.3</p>
            <p>Compatibility: Android 7.0+</p>
            <p>Size: 23.8 MB</p>
          </div>
          <div class="download-links">
            <a href="#" class="download-btn web-download" @click.prevent="downloadForAndroid">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
                <path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
              </svg>
              Web Download
            </a>
          </div>
        </div>
      </div>
      
      <div class="qr-section">
        <div class="qr-container">
          <div class="qr-code">
            <div class="qr-placeholder"></div>
          </div>
          <div class="qr-text">
            <h3>Scan QR Code to Download</h3>
            <p>Use your phone camera to scan the QR code<br>to access the download page directly</p>
          </div>
        </div>
      </div>
      
      <div class="download-info">
        <div class="info-item">
          <div class="info-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
              <path fill="currentColor" d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8z"/>
            </svg>
          </div>
          <div class="info-content">
            <h4>Secure & Reliable</h4>
            <p>All applications have passed security testing<br>No malicious code, protecting your privacy</p>
          </div>
        </div>
        
        <div class="info-item">
          <div class="info-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
              <path fill="currentColor" d="M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm42.5 150.4L242.2 95c-8.8-8.8-23.1-8.8-31.9 0L129.9 175.4c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64.1-64.1 80.6 80.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM256 512c141.4 0 256-114.6 256-256c0-37.3-7.9-72.7-22.1-104.7c-7.6-17-27.6-24.4-44.6-16.8s-24.4 27.6-16.8 44.6C439.4 206.1 446 230.5 446 256c0 105-85 190-190 190S66 361 66 256c0-25.5 6.6-49.9 17.5-76.9c7.6-17-1.8-37-18.8-44.6s-37 1.8-44.6 18.8C5.9 185.6 0 220.2 0 256C0 397.4 114.6 512 256 512z"/>
            </svg>
          </div>
          <div class="info-content">
            <h4>Auto Updates</h4>
            <p>Built-in automatic update function<br>Ensuring you always use the latest version</p>
          </div>
        </div>
        
        <div class="info-item">
          <div class="info-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
              <path fill="currentColor" d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/>
            </svg>
          </div>
          <div class="info-content">
            <h4>Free Account</h4>
            <p>Register for a free account<br>Sync favorites and listening history</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 添加模态框 -->
    <div class="modal" v-if="showModal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="48" height="48">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
          </svg>
        </div>
        <h3>Coming Soon!</h3>
        <p>Android version is under development.<br>Stay tuned for the release!</p>
        <button class="modal-btn" @click="closeModal">Got it</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GO FM Radio - Music & Sports',
  data() {
    return {
      iosLink: 'https://apps.apple.com/us/app/go-fm-radio-music-sports/id6648771859',
      androidLink: 'https://play.google.com/store/apps/details?id=com.your.fmradio',
      showModal: false
    }
  },
  methods: {
    downloadForIOS() {
      try {
        console.log('准备跳转到iOS下载链接');
        window.location.href = this.iosLink;
      } catch (error) {
        console.error('iOS下载跳转出错:', error);
      }
    },
    downloadForAndroid() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<style scoped>
.download {
  padding: 8rem 0;
  background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
  position: relative;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 2;
}

.section-header {
  text-align: center;
  margin-bottom: 5rem;
  animation: fade-in 1s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-header h2 {
  font-size: 3.2rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  color: #1e293b;
  position: relative;
  display: inline-block;
}

.highlight {
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 0 0.5rem;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  border-radius: 2px;
  opacity: 0.5;
}

.section-header p {
  font-size: 1.4rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.platforms {
  display: flex;
  justify-content: center;
  gap: 3.5rem;
  margin-bottom: 5rem;
}

.platform-card {
  background: white;
  border-radius: 1.8rem;
  padding: 3.5rem;
  box-shadow: 0 15px 50px rgba(15, 23, 42, 0.08);
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(226, 232, 240, 0.8);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.platform-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.platform-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.12);
  border-color: rgba(59, 130, 246, 0.3);
}

.platform-card:hover::before {
  opacity: 1;
}

.platform-icon {
  width: 90px;
  height: 90px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  font-size: 2.2rem;
  transition: all 0.4s ease;
  color: white;
  transform: rotate(0deg);
}

.platform-card:hover .platform-icon {
  transform: rotate(5deg) scale(1.05);
}

.platform-icon.apple {
  background: linear-gradient(135deg, #333333, #000000);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.platform-icon.android {
  background: linear-gradient(135deg, #4CAF50, #2E7D32);
  box-shadow: 0 15px 30px rgba(76, 175, 80, 0.2);
}

.platform-icon svg {
  width: 48px;
  height: 48px;
}

.platform-card h3 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.8rem;
  color: #1e293b;
}

.platform-details {
  width: 100%;
  text-align: center;
  margin-bottom: 2.5rem;
  padding: 1.5rem;
  background: rgba(248, 250, 252, 0.8);
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.platform-details p {
  margin: 0.8rem 0;
  color: #64748b;
  font-size: 1.15rem;
  line-height: 1.5;
}

.download-links {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
  margin-bottom: 2rem;
}

.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 1.2rem;
  border-radius: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 1.1rem;
  width: 100%;
}

.web-download {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
  position: relative;
  overflow: hidden;
}

.web-download::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: rotate(30deg);
  transition: transform 0.5s;
}

.web-download:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(37, 99, 235, 0.3);
}

.web-download:hover::after {
  transform: rotate(30deg) translate(80%, 0);
}

/* QR码部分 */
.qr-section {
  background: white;
  border-radius: 2rem;
  padding: 4rem;
  margin-bottom: 5rem;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.8);
  position: relative;
  overflow: hidden;
}

.qr-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03) 0%, rgba(96, 165, 250, 0.05) 100%);
  z-index: 0;
}

.qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  position: relative;
  z-index: 1;
}

.qr-code {
  flex-shrink: 0;
  transform: rotate(-2deg);
  transition: all 0.3s ease;
}

.qr-code:hover {
  transform: rotate(0) scale(1.02);
}

.qr-placeholder {
  width: 200px;
  height: 200px;
  background: rgba(59, 130, 246, 0.05);
  border: 2px dashed rgba(59, 130, 246, 0.3);
  border-radius: 16px;
  position: relative;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
  transition: all 0.3s ease;
}

.qr-placeholder:hover {
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
}

.qr-placeholder::before,
.qr-placeholder::after {
  content: '';
  position: absolute;
  background-color: rgba(59, 130, 246, 0.2);
}

.qr-placeholder::before {
  top: 50%;
  left: 10%;
  right: 10%;
  height: 2px;
  transform: translateY(-50%);
}

.qr-placeholder::after {
  left: 50%;
  top: 10%;
  bottom: 10%;
  width: 2px;
  transform: translateX(-50%);
}

.qr-text h3 {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1e293b;
  position: relative;
  display: inline-block;
}

.qr-text h3::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  border-radius: 3px;
}

.qr-text p {
  font-size: 1.2rem;
  color: #64748b;
  line-height: 1.8;
}

/* 下载信息部分 */
.download-info {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.info-item {
  background: white;
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(226, 232, 240, 0.8);
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.info-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #3b82f6, #60a5fa);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.info-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.1);
}

.info-item:hover::before {
  opacity: 1;
}

.info-icon {
  width: 65px;
  height: 65px;
  border-radius: 18px;
  background: rgba(59, 130, 246, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.info-item:hover .info-icon {
  background: rgba(59, 130, 246, 0.15);
  transform: scale(1.05);
}

.info-content h4 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.8rem;
  color: #1e293b;
}

.info-content p {
  font-size: 1rem;
  color: #64748b;
  line-height: 1.7;
}

/* 响应式样式 */
@media (max-width: 992px) {
  .platforms {
    flex-direction: column;
    align-items: center;
    gap: 3rem;
  }
  
  .platform-card {
    max-width: 100%;
    padding: 3rem;
  }
  
  .download-info {
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 2.8rem;
  }
  
  .qr-section {
    padding: 3rem;
  }
}

@media (max-width: 768px) {
  .platforms {
    flex-direction: column;
    align-items: center;
  }
  
  .platform-card {
    max-width: 100%;
  }
  
  .qr-container {
    flex-direction: column;
    gap: 2.5rem;
  }
  
  .qr-text {
    text-align: center;
  }
  
  .qr-text h3::after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .info-item {
    padding: 2rem;
    gap: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 2.5rem;
  }
  
  .section-header p {
    font-size: 1.2rem;
  }
  
  .download {
    padding: 6rem 0 8rem;
  }
}

@media (max-width: 640px) {
  .download {
    padding: 6rem 0;
  }
  
  .section-header {
    margin-bottom: 3.5rem;
  }
  
  .section-header h2 {
    font-size: 2.4rem;
  }
  
  .section-header p {
    font-size: 1.2rem;
  }
  
  .platform-card {
    padding: 2.5rem 1.5rem;
  }
  
  .platform-icon {
    width: 80px;
    height: 80px;
  }
  
  .platform-icon svg {
    width: 42px;
    height: 42px;
  }
  
  .platform-card h3 {
    font-size: 1.8rem;
  }
  
  .qr-section {
    padding: 2.5rem 1.5rem;
  }
  
  .qr-placeholder {
    width: 180px;
    height: 180px;
  }
  
  .qr-text h3 {
    font-size: 1.8rem;
  }
  
  .info-icon {
    width: 55px;
    height: 55px;
  }
  
  .info-item {
    padding: 1.8rem;
  }
}

/* 添加平台卡片高亮动画效果 */
@keyframes highlight-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(59, 130, 246, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

.highlight-platform {
  animation: highlight-pulse 1.5s infinite;
  border-color: #3b82f6 !important;
  transform: translateY(-10px);
}

/* 平台卡片高亮动画效果 */
@keyframes platformHighlight {
  0% {
    box-shadow: 0 10px 30px rgba(37, 99, 235, 0.2);
    transform: translateY(0);
  }
  50% {
    box-shadow: 0 20px 40px rgba(37, 99, 235, 0.4);
    transform: translateY(-10px);
  }
  100% {
    box-shadow: 0 10px 30px rgba(37, 99, 235, 0.2);
    transform: translateY(0);
  }
}

.platform-card.highlight-platform {
  animation: platformHighlight 3s ease;
}

/* 设备检测按钮样式 */
.device-detection {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.9rem 2rem;
  border-radius: 0.8rem;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.25);
  position: relative;
  overflow: hidden;
}

.btn-primary::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: rotate(30deg);
  transition: transform 0.5s;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.35);
}

.btn-primary:hover::after {
  transform: rotate(30deg) translate(80%, 0);
}

.btn-primary:active {
  transform: translateY(-1px);
}

/* 添加模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: modalFadeIn 0.3s ease;
}

.modal-content {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  text-align: center;
  max-width: 400px;
  width: 90%;
  position: relative;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.15);
  animation: modalSlideIn 0.3s ease;
}

.modal-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  color: white;
  animation: iconPop 0.5s ease;
}

.modal-content h3 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
}

.modal-content p {
  font-size: 1.1rem;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.modal-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 0.8rem;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.25);
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalSlideIn {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes iconPop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style> 